import { useEffect, useState, useRef } from "react";
import WidgetsOutlinedIcon from "@mui/icons-material/WidgetsOutlined";
import SearchIcon from "../assets/searchIcon.svg";
import Select from "react-select";
import { handleApiErrorResponses } from "../utils/ApisErrorHandling";
import CustomPagination from "../utils/paginationUtils";
import "./HsaReportForCC.scss";
import { ReportServices } from "../services/ReportServices";
import { HospitalServices } from "../services/HospitalServices";
import { CircularProgress } from "@mui/material";
import formatDateTimeLocal from "../utils/formatDateTimeUtil";
const HsaReportForCC = () => {
  const [loading, setLoading] = useState(false);
  const [reportData, setReportData] = useState([]);
  const [hospitalList, setHospitalList] = useState([]);
  const [hospitalId, setHospitalId] = useState("");
  const [caseStatus, setCaseStatus] = useState("");
  const [searchKey, setSearchKey] = useState("");
  const [selectedDocType, setSelectedDocType] = useState("ADMISSION");
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [diffStageCount, setDiffStageCount] = useState(null);
  const [sortByTime, setSortByTime] = useState("processTime");
  const [filterByDateType, setFilterByDateType] = useState("createdAt");
  let prevDate = new Date();
  prevDate.setDate(prevDate.getDate() - 1);
  const [startDate, setStartDate] = useState(formatDateTimeLocal(prevDate));
  const [endDate, setEndDate] = useState(formatDateTimeLocal(new Date())); //current date
  let limit = 10;
  const searchTimeRef = useRef();
  const handleSearch = (e) => {
    if (searchTimeRef.current) {
      clearTimeout(searchTimeRef.current);
    }
    searchTimeRef.current = setTimeout(() => {
      setSearchKey(e.target.value);
    }, 500);
  };
  const handleStartDateChange = (e) => {
    setStartDate(e.target.value);
  };

  const handleEndDateChange = (e) => {
    setEndDate(e.target.value);
  };
  function getTime(totalSeconds) {
    const days = Math.floor(totalSeconds / (3600 * 24));
    const hours = Math.floor((totalSeconds % (3600 * 24)) / 3600);
    const mins = Math.floor((totalSeconds % 3600) / 60);
    const secs = Math.floor(totalSeconds % 60);

    let result = "";

    if (days > 0) result += `${days}D: `;
    if (hours > 0 || days > 0) result += `${hours}H: `;
    if (mins > 0 || hours > 0 || days > 0) result += `${mins}M: `;
    if (secs > 0) result += `${secs}S`;
    return result;
  }
  const formatDate = (date) => {
    date = new Date(date);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Months are 0-indexed, so we add 1
    const day = date.getDate().toString().padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  const getLatestEnhancementStage = (enhancement) => {
    if (!enhancement) return null;
    const numericKeys = Object.keys(enhancement).filter((key) =>
      /^\d+$/.test(key),
    );
    if (numericKeys.length === 0) return null;
    const lastKey = numericKeys.sort((a, b) => Number(a) - Number(b)).pop();
    return enhancement[lastKey];
  };
  const getHospitalList = async () => {
    try {
      const response = await HospitalServices.gethospitals("", 1, 1500);
      setHospitalList(response.data.list);
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };
  const getDifferentStageCount = async () => {
    try {
      const res = await ReportServices.getDiffStageCaseCount(
        hospitalId,
        startDate,
        endDate,
        searchKey,
      );
      setDiffStageCount(res?.data);
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };
  const getCasesReport = async () => {
    setLoading(true);
    try {
      const res = await ReportServices.getHsaReport(
        page,
        limit,
        hospitalId,
        selectedDocType,
        startDate,
        endDate,
        searchKey,
      );
      setReportData(res?.data?.docTimeReport);
      setTotalPages(res?.data?.totalPages);
    } catch (error) {
      handleApiErrorResponses(error);
    }
    setLoading(false);
  };
  useEffect(() => {
    getHospitalList();
  }, []);
  useEffect(() => {
    getCasesReport();
  }, [page, startDate, endDate, selectedDocType, hospitalId, searchKey]);
  useEffect(() => {
    getDifferentStageCount();
  }, [startDate, endDate, hospitalId, searchKey]);
  console.log("report data:", reportData);
  return (
    <div className="manage-box w-full overflow-hidden">
      {" "}
      <span className="path_line">
        <WidgetsOutlinedIcon style={{ height: "24px" }} /> &nbsp; &nbsp;/ &nbsp;
        &nbsp;HSA Report Hospital Wise
      </span>
      <div>
        <div className="heading">HSA Report Hospital Wise</div>
      </div>
      <div className="flex justify-between items-center text-[12px] xl:text-[14px] 2xl:text-[16px]">
        <div className="flex gap-3">
          <div>
            <label htmlFor="start-date">Start Date:</label>
            <input
              type="datetime-local"
              id="start-date"
              // value={formatDate(startDate)}
              value={startDate}
              onChange={handleStartDateChange}
              max={formatDate(new Date())}
              style={{ border: "1px solid #E5E5E5" }}
              className="text-[#191919] appearance-none p-2 rounded-[8px] "
            />
          </div>

          <div>
            <label htmlFor="end-date">End Date:</label>
            <input
              type="datetime-local"
              id="end-date"
              // value={formatDate(endDate)}
              value={endDate}
              onChange={handleEndDateChange}
              max={formatDate(new Date())}
              style={{ border: "1px solid #E5E5E5" }}
              className="text-[#191919] appearance-none p-2 rounded-[8px] "
            />
          </div>
          <Select
            name="hospitalId"
            isClearable
            options={hospitalList}
            getOptionLabel={(options) => {
              return options["name"];
            }}
            getOptionValue={(options) => {
              return options["id"];
            }}
            onChange={(item) => {
              // setPage(1);
              item ? setHospitalId(item.id) : setHospitalId("");
            }}
            value={hospitalList.filter((item) => item.id === hospitalId)}
            placeholder="FILTER HOSPITAL WISE"
          />
        </div>
        <div
          style={{ border: "1px solid #E4E4E4" }}
          className="w-[270px] flex gap-1 items-center py-1 px-2 rounded-[4px]"
        >
          <img src={SearchIcon} alt="search-icon" />
          <input
            type="text"
            onChange={handleSearch}
            className="w-full border-none outline-none"
            placeholder="Patient Name / Beneficiary Number"
          />
        </div>
      </div>
      <hr
        style={{ width: "100%", border: "1px solid rgba(228, 228, 228, 1)" }}
      />
      <div className="flex justify-between items-center mt-2">
        <div className="flex gap-5 text-[12px] xl:text-[14px] 2xl:text-[16px] mb-2">
          <div
            className={` ${
              selectedDocType == "ADMISSION"
                ? "text-white bg-[#017C57] shadow-lg"
                : "text-[#017C57] bg-white shadow-md"
            }  border border-solid border-[#017C57] px-3 xl:px-5 py-2 xl:py-3 rounded-full cursor-pointer`}
            onClick={() => {
              setSelectedDocType("ADMISSION");
              setPage(1);
            }}
          >
            Admission ({diffStageCount?.admission})
          </div>
          <div
            className={` ${
              selectedDocType == "ENHANCEMENT"
                ? "text-white bg-[#017C57] shadow-lg"
                : "text-[#017c57] bg-white shadow-md"
            }  border border-solid border-[#017c57] px-3 xl:px-5 py-2 xl:py-3 rounded-full cursor-pointer`}
            onClick={() => {
              setSelectedDocType("ENHANCEMENT");
              setPage(1);
            }}
          >
            Enhancement ({diffStageCount?.enhancement})
          </div>
          <div
            className={` ${
              selectedDocType == "DISCHARGE"
                ? "text-white bg-[#017C57] shadow-lg"
                : "text-[#017C57] bg-white shadow-md"
            }  border border-solid border-[#017C57] px-3 xl:px-5 py-2 xl:py-3 rounded-full cursor-pointer`}
            onClick={() => {
              setSelectedDocType("DISCHARGE");
              setPage(1);
            }}
          >
            Discharge/Claim ({diffStageCount?.discharge})
          </div>
        </div>
      </div>
      <div
        style={{ border: "1px solid #e4e4e4", marginTop: "24px" }}
        className="min-h-[50vh] rounded-[16px] p-5 overflow-x-auto"
      >
        {" "}
        {loading ? (
          <div className="flex justify-center">
            <CircularProgress />
          </div>
        ) : (
          <div>
            <div
              className={`grid grid-cols-12 gap-0.5 text-[#797979] text-[12px] xl:text-[14px] 2xl:text-[16px]  px-2 xl:px-4 2xl:px-8`}
            >
              <div>
                <div className="text-[#191919] font-semibold mb-4">
                  Registered On
                </div>
              </div>
              <div>
                <div className="text-[#191919] font-semibold mb-4">
                  Patient name
                </div>
              </div>
              <div>
                <div className="text-[#191919] font-semibold mb-4">
                  Beneficiary No
                </div>
              </div>
              <div>
                <div className="text-[#191919] font-semibold mb-4">
                  Total Est. Time
                </div>
              </div>
              <div>
                <div className="text-[#191919] font-semibold mb-4">
                  Total Time
                </div>
              </div>
              <div>
                <div className="text-[#191919] font-semibold mb-4">
                  {" "}
                  Initiate Time
                </div>
              </div>
              <div>
                <div className="text-[#191919] font-semibold mb-4">
                  {" "}
                  Documents
                </div>
              </div>
              <div>
                <div className="text-[#191919] font-semibold mb-4">
                  {" "}
                  Doc Uploaded
                </div>
              </div>
              <div>
                <div className="text-[#191919] font-semibold mb-4">
                  {" "}
                  Rejection times AI
                </div>
              </div>
              <div>
                <div className="text-[#191919] font-semibold mb-4">
                  {" "}
                  AI Rejected Doc Upload
                </div>
              </div>
              <div>
                <div className="text-[#191919] font-semibold mb-4">
                  {" "}
                  Reject time TMS
                </div>
              </div>
              <div>
                <div className="text-[#191919] font-semibold mb-4">
                  {" "}
                  TMS Rejected Upload
                </div>
              </div>
            </div>

            {reportData?.length > 0 ? (
              reportData?.map((rep, idx) => {
                return (
                  <div
                    key={idx}
                    className={`py-6 px-2 xl:px-4 2xl:px-8 rounded-[16px] ${
                      idx % 2 === 0 ? "bg-white" : "bg-[#F7F7F7]"
                    }`}
                  >
                    <div
                      className={`grid grid-cols-12 gap-0.5  text-[#797979] text-[12px]   xl:text-[14px] 2xl:text-[16px] `}
                    >
                      <div>
                        <div>
                          {rep?.patient?.registeredDate
                            ? new Date(
                                rep?.patient?.registeredDate,
                              )?.toLocaleString("en-GB", {
                                year: "numeric",
                                month: "2-digit",
                                day: "2-digit",
                                hour: "2-digit",
                                minute: "2-digit",
                                second: "2-digit",
                                hour12: true,
                              })
                            : "--"}
                        </div>
                      </div>
                      <div title={rep?.patient?.patientName}>
                        <div className="overflow-hidden whitespace-nowrap text-ellipsis">
                          {rep?.patient?.patientName || "--"}
                        </div>
                      </div>
                      <div title={rep?.patient?.beneficiaryNo}>
                        <div className="overflow-hidden whitespace-nowrap text-ellipsis">
                          {rep?.patient?.beneficiaryNo || "--"}
                        </div>
                      </div>
                      <div>
                        <div>
                          {getTime(
                            rep?.initiateTimeReport?.totalExpectedTime,
                          ) || "--"}
                        </div>
                      </div>
                      <div>
                        <div
                          className={`${
                            rep?.initiateTimeReport?.totalTime >
                            rep?.initiateTimeReport?.totalExpectedTime
                              ? "text-red-500"
                              : "text-green-500"
                          }`}
                        >
                          {getTime(rep?.initiateTimeReport?.totalTime) || "--"}
                        </div>
                      </div>
                      <div>
                        <div>
                          {selectedDocType === "ADMISSION"
                            ? getTime(
                                rep?.initiateTimeReport?.admission
                                  ?.admission_initiate_time,
                              ) || "--"
                            : selectedDocType === "ENHANCEMENT"
                              ? getTime(
                                  getLatestEnhancementStage(
                                    rep?.initiateTimeReport?.enhancement,
                                  )?.initiate_time,
                                ) || "--"
                              : selectedDocType === "DISCHARGE"
                                ? getTime(
                                    rep?.initiateTimeReport?.claim
                                      ?.claim_initiate_time,
                                  ) || "--"
                                : "--"}
                        </div>
                      </div>
                      <div>
                        <div>
                          {selectedDocType === "ADMISSION"
                            ? rep?.ADMISSIONDOCUMENTS || "--"
                            : selectedDocType === "ENHANCEMENT"
                              ? (rep?.ENHANCEMENTDOCUMENTS &&
                                  rep?.ENHANCEMENTDOCUMENTS[
                                    `ENHANCEMENT${
                                      Object.keys(rep?.ENHANCEMENTDOCUMENTS)
                                        .length
                                    }`
                                  ]) ||
                                "--"
                              : selectedDocType === "DISCHARGE"
                                ? rep?.DISCHARGEDOCUMENTS || "--"
                                : "--"}
                        </div>
                      </div>
                      <div>
                        <div>
                          {selectedDocType === "ADMISSION"
                            ? getTime(
                                rep?.initiateTimeReport?.admission
                                  ?.ai_admission_doc_upload_time,
                              ) || "--"
                            : selectedDocType === "ENHANCEMENT"
                              ? getTime(
                                  getLatestEnhancementStage(
                                    rep?.initiateTimeReport?.enhancement,
                                  )?.ai_enhancement_doc_upload_time,
                                ) || "--"
                              : selectedDocType === "DISCHARGE"
                                ? getTime(
                                    rep?.initiateTimeReport?.claim
                                      ?.ai_claim_doc_upload_time,
                                  ) || "--"
                                : "--"}
                        </div>
                      </div>
                      <div>
                        <div>
                          {selectedDocType === "ADMISSION"
                            ? rep?.initiateTimeReport?.admission
                                ?.ai_rejection_times || "--"
                            : selectedDocType === "ENHANCEMENT"
                              ? getLatestEnhancementStage(
                                  rep?.initiateTimeReport?.enhancement,
                                )?.ai_rejection_times || "--"
                              : selectedDocType === "DISCHARGE"
                                ? rep?.initiateTimeReport?.claim
                                    ?.ai_rejection_times || "--"
                                : "--"}
                        </div>
                      </div>
                      <div>
                        <div>
                          {selectedDocType === "ADMISSION"
                            ? getTime(
                                rep?.initiateTimeReport?.admission
                                  ?.ai_admission_reject_doc_reupload_time,
                              ) || "--"
                            : selectedDocType === "ENHANCEMENT"
                              ? getTime(
                                  getLatestEnhancementStage(
                                    rep?.initiateTimeReport?.enhancement,
                                  )?.ai_enhancement_reject_doc_reupload_time,
                                ) || "--"
                              : selectedDocType === "DISCHARGE"
                                ? getTime(
                                    rep?.initiateTimeReport?.claim
                                      ?.ai_claim_reject_doc_reupload_time,
                                  ) || "--"
                                : "--"}
                        </div>
                      </div>
                      <div>
                        <div>
                          {selectedDocType === "ADMISSION"
                            ? rep?.initiateTimeReport?.admission
                                ?.tms_rejection_times || "--"
                            : selectedDocType === "ENHANCEMENT"
                              ? getLatestEnhancementStage(
                                  rep?.initiateTimeReport?.enhancement,
                                )?.tms_rejection_times || "--"
                              : selectedDocType === "DISCHARGE"
                                ? rep?.initiateTimeReport?.claim
                                    ?.tms_rejection_times || "--"
                                : "--"}
                        </div>
                      </div>
                      <div>
                        <div>
                          {selectedDocType === "ADMISSION"
                            ? getTime(
                                rep?.initiateTimeReport?.admission
                                  ?.tms_admission_reject_doc_reupload_time,
                              ) || "--"
                            : selectedDocType === "ENHANCEMENT"
                              ? getTime(
                                  getLatestEnhancementStage(
                                    rep?.initiateTimeReport?.enhancement,
                                  )?.tms_enhancement_reject_doc_reupload_time,
                                ) || "--"
                              : selectedDocType === "DISCHARGE"
                                ? getTime(
                                    rep?.initiateTimeReport?.claim
                                      ?.tms_claim_reject_doc_reupload_time,
                                  ) || "--"
                                : "--"}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })
            ) : (
              <div className="h-[300px] text-xl flex justify-center items-center font-semibold">
                No Data Found. Try other filters
              </div>
            )}
          </div>
        )}
        {reportData?.length > 0 && (
          <div className="flex justify-center mt-2">
            {" "}
            <CustomPagination
              page={page}
              totalPages={totalPages}
              setPage={setPage}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default HsaReportForCC;
